import { inject, Injectable } from '@angular/core';
import { NotificationModel } from '@app/pages/notifications/models/notification-model';
import { ActivityTextStrategyFactory } from './factory/activity-text-strategy-factory';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';

@Injectable({
  providedIn: 'root'
})

export class ActivityDescriptionService {
  constructor(private factory: ActivityTextStrategyFactory) { }

  public generateNotification(activity: ActivitiesAggrigatorModel, isAffectedContent = false): string {
    const verb = activity?.verb;
    if (!verb) {
      return '';
    }

    const strategy = this.factory.create(verb!);
    const message = strategy.createText(activity, isAffectedContent);

    return message as string;
  }
}
